import styled from "styled-components";

export const Input = styled.input``;

export const Label = styled.label``;

export const Rating = styled.div`
  display: flex;
  width: 300px;
  justify-content: center;
  flex-direction: row-reverse;
  position: relative;

  ${Input}:checked ~ ${Label}, ${Input}:checked ~ ${Label} ~ ${Label} {
    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: #79D9D9;
      font-size: 2em;
    }
  }

  ${Input}:not(:checked)
    ~ ${Label}:hover,
    ${Input}:not(:checked)
    ~ ${Label}:hover
    ~ ${Label} {
    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: #79D9D9;
      font-size: 2em;
    }
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.2s;
    animation-fill-mode: both;
  }

  &.animated.delay {
    animation-delay: 0.3s;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  pointer-events: ${(props) => props.noPointerEvents !== null && "none"};

  ${Rating} > ${Input} {
    display: none;
  }

  ${Rating} > ${Label} {
    cursor: pointer;
    width: 45px;
    height: 35px;
    transition: 0.3s;

    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: lightgray;
      font-size: 2em;
      transition: 0.1s;
    }
  }
`;

export const Title = styled.div`
  display: flex;
  margin: 20px 0;
  justify-content: center;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 1.1em;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.2s;
    animation-fill-mode: both;
  }

  &.animated.delay {
    animation-delay: 0.15s;
  }
`;

export const StepCount = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 0.8em;
`;
